export type SingleDialingCode = {
	codes: number[];
	country: string;
};

const model: types.models.InputModel = {
	codes: ['codes', []],
	country: 'country',
};

export default model;
